<template>
    <a-drawer placement="right" :closable="false" :visible="showDrawer" @close="close" width="70%"
        :style="{ transform: 'none' }">
        <a-spin v-if="loading" size="large" class="loading" />
        <div v-else>
            <div class="header">
                <div class="title">
                    {{ isAdd ? '新建课程' : '修改课程' }}
                </div>
                <a class="close-img" @click="close">
                    <img src="../../../../public/close.png" alt="" />
                </a>
            </div>
            <div class="form-box">
                <a-spin :spinning="disabledSpin" tip="上传中，请稍后...">
                    <div class="course-form">
                        <a-steps :current="current" style="margin-bottom: 16px;">
                            <a-step v-for="item in steps" :key="item.title" :title="item.title" />
                        </a-steps>

                        <a-form class="max-height" layout="horizontal" :form="form" v-show="current == 0">
                            <!-- 平台课程选择 修改这里不能选择-->
                            <a-form-item label="平台课程选择" :labelCol="{ lg: { span: 7 } }"
                                :wrapperCol="{ lg: { span: 13 } }" v-if="platformCourse && isAdd">
                                <a-select showSearch placeholder="请选择平台的课" :filterOption="false" @search="searchCourse"
                                    @change="courseChange" @focus="searchCourse" :notFoundContent="searchLoading_course ? undefined : '没有查询结果'
                                        ">
                                    <a-spin v-if="searchLoading_course" slot="notFoundContent" size="small" />
                                    <a-select-option v-for="d in courseList" :key="d.id">{{
                                        d.courseName
                                        }}</a-select-option>
                                </a-select>
                            </a-form-item>

                            <!-- 封面上传 -->
                            <a-form-item label="封面上传" :labelCol="{ lg: { span: 7 } }"
                                :wrapperCol="{ lg: { span: 13 } }">
                                <c-upload accept="image/*" ossType="avatar" :isSingle="true" :maxFileSize="2097152"
                                    @uploadSuccess="uploadSuccess" :sourceFileList="sourceFileList"
                                    :disabled="platformCourse"></c-upload>
                            </a-form-item>

                            <!-- 课程名字 -->
                            <a-form-item label="课程名字" :labelCol="{ lg: { span: 7 } }"
                                :wrapperCol="{ lg: { span: 13 } }">
                                <a-input :disabled="platformCourse" v-decorator="[
                                    'courseName',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                pattern: /^.{2,45}$/,
                                                message: '请输入长度为2~45位的课程名字',
                                            },
                                        ],
                                        validateTrigger: 'change',
                                    },
                                ]" />
                                <div class="shelter"></div>
                            </a-form-item>

                            <!-- 课程分类 -->
                            <a-form-item label="课程分类" :labelCol="{ lg: { span: 7 } }"
                                :wrapperCol="{ lg: { span: 13 } }">
                                <!-- @change="classifyIdChange" -->
                                <a-select placeholder="请选择" :disabled="platformCourse || !this.isAdd"
                                    @change="classifyIdChange" v-decorator="[
                                        'classifyId',
                                        { rules: [{ required: true, message: '请选择' }] },
                                    ]">
                                    <a-select-option v-for="(item, index) in $store.getters.getClassify2" :key="index"
                                        :value="item.id">{{ item.tagName }}</a-select-option>
                                </a-select>
                                <div style="line-height: 30px;">注：仅新建课程时允许选择课程分类</div>
                            </a-form-item>

                            <a-form-item label="课程类目" :labelCol="{ lg: { span: 7 } }"
                                :wrapperCol="{ lg: { span: 13 } }">
                                <a-cascader :options="$store.state.common.courseCateLevel" :fieldNames="{
                                    label: 'name',
                                    value: 'id',
                                    children: 'children',
                                }" :disabled="platformCourse" placeholder="请选择" v-decorator="[
                                    'cateList',
                                    { rules: [{ required: true, message: '请选择课程类目' }] },
                                ]" />
                            </a-form-item>

                            <!-- 适用年级 -->
                            <a-form-item label="适用年级" :labelCol="{ lg: { span: 7 } }"
                                :wrapperCol="{ lg: { span: 13 } }">
                                <a-select mode="multiple" :disabled="platformCourse" placeholder="请选择" v-decorator="[
                                    'gradeScope',
                                    { rules: [{ required: true, message: '请选择' }] },
                                ]"><a-select-option v-for="(item, index) in schoolGradeList" :key="index"
                                        :value="item.gradeTagId.toString()">
                                        {{ item.gradeName }}
                                    </a-select-option>
                                </a-select>
                                <div v-if="errGradeText && classifyIdValue != 3" class="errGrade">{{ errGradeText }}
                                    不在当前允许的年级范围内</div>
                            </a-form-item>

                            <!-- Web地址 -->
                            <a-form-item label="Web地址" :labelCol="{ lg: { span: 7 } }"
                                v-if="form.getFieldValue('resourceType') == '2'" :wrapperCol="{ lg: { span: 13 } }">
                                <a-input type="text" :disabled="platformCourse" v-decorator="['webUrl']" />
                            </a-form-item>

                            <!-- 报名人数范围 -->
                            <a-form-item label="报名人数范围" :labelCol="{ lg: { span: 7 } }"
                                :wrapperCol="{ lg: { span: 13 } }">
                                <a-input-group compact>
                                    <a-input-number :min="1" :max="1000" :disabled="platformCourse" class="person-scope"
                                        placeholder="请输入" @change="lowerLimitChange" v-decorator="[
                                            'lowerLimit',
                                            { rules: [{ required: true, message: '' }] },
                                        ]" :class="{ noUpper: upperFlag }" />
                                    <a-input class="person-gap" placeholder="~" disabled
                                        :class="{ noUpper2: upperFlag }" />
                                    <a-input-number
                                        :min="form.getFieldValue('lowerLimit') ? form.getFieldValue('lowerLimit') + 1 : 2"
                                        :max="100000" :disabled="platformCourse" class="person-scope max-person"
                                        style="border-left: none;" placeholder="请输入" @change="upperLimitChange"
                                        v-decorator="[
                                            'upperLimit',
                                            { rules: [{ required: true, message: '请输入' }] },
                                        ]" :class="{ noUpper3: upperFlag }" />
                                </a-input-group>
                                <div class="upper-explain" v-show="upperFlag">请输入</div>
                            </a-form-item>
                            <!-- 建议教学时长范围 -->
                            <a-form-item label="建议教学时长范围" :labelCol="{ lg: { span: 7 } }"
                                :wrapperCol="{ lg: { span: 13 } }">
                                <a-select style="width: 80px" :disabled="platformCourse" v-decorator="[
                                    'teachingTime_start',
                                    { rules: [{ required: true, message: '请选择' }] },
                                ]">
                                    <a-select-option :value="item" v-for="(item, index) in gapTime" :key="index">{{
                                        item }}</a-select-option>
                                </a-select>
                                <span class="select-desc">分钟</span>
                                <span class="select-and">~</span>
                                <a-select style="width: 80px" :disabled="platformCourse" v-decorator="[
                                    'teachingTime_end',
                                    { rules: [{ required: true, message: '请选择' }] },
                                ]">
                                    <a-select-option :value="item" v-for="(item, index) in gapTime" :key="index">{{
                                        item }}</a-select-option>
                                </a-select>
                                <span class="select-desc">分钟</span>
                                <div class="form-desc">建议上限浮动范围不超过30分钟</div>
                            </a-form-item>

                            <!-- 上课周期 -->
                            <a-form-item label="上课周期" :labelCol="{ lg: { span: 7 } }"
                                :wrapperCol="{ lg: { span: 13 } }">
                                <a-select mode="multiple" :disabled="platformCourse" placeholder="请选择"
                                    @change="classWeeks_change()" v-decorator="[
                                        'classWeeks',
                                        { rules: [{ required: true, message: '请选择' }] },
                                    ]">
                                    <a-select-option v-for="(item, index) in weekList" :key="index"
                                        :value="item.code.toString()">{{ item.value }}</a-select-option>
                                </a-select>
                            </a-form-item>

                            <!-- 场地备注 -->
                            <a-form-item label="场地备注" :labelCol="{ lg: { span: 7 } }"
                                :wrapperCol="{ lg: { span: 13 } }">
                                <a-input type="textarea" :disabled="platformCourse" v-decorator="[
                                    'placeRemark',
                                    {
                                        rules: [
                                            {
                                                pattern: /^.{0,400}$/,
                                                message: '请输入长度为1~400位的场地备注',
                                            },
                                        ],
                                        validateTrigger: 'change',
                                    },
                                ]" />
                                <div class="shelter"></div>
                            </a-form-item>

                            <!-- 课程级别 -->
                            <a-form-item label="课程级别" :labelCol="{ lg: { span: 7 } }"
                                :wrapperCol="{ lg: { span: 13 } }">
                                <a-select :disabled="platformCourse" placeholder="请选择" v-decorator="[
                                    'courseLevel',
                                    { rules: [{ required: true, message: '请选择' }] },
                                ]">
                                    <a-select-option v-for="(item, index) in courseLevelList" :key="index"
                                        :value="item.code.toString()">{{ item.value }}</a-select-option>
                                </a-select>
                            </a-form-item>

                            <!-- 课时数 -->
                            <a-form-item label="课时数" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
                                <a-input-number :min="1" :max="1000" :disabled="platformCourse" style="width: 100%"
                                    @change="handleClassHoursChange" v-decorator="[
                                        'classHours',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    pattern: /^\d{1,1000}$/,
                                                    message: '请输入正整数',
                                                },
                                            ],
                                            validateTrigger: 'change',
                                        },
                                    ]" />
                                <!-- 课时提示 -->
                                <p class="course-info">填写开班时一学期安排的课时数</p>
                                <div v-if="classifyIdValue == 1 || classifyIdValue == 2">
                                    <p class="course-info" v-show="classCycle">
                                        ⚠ 如果上课周期为每周{{ classFrequency }}节，当前课时预计持续时间为{{ classCycle }}周<span>
                                            (约为{{ Math.round(classCycle / 4.25) }}个月)</span>，
                                        <span v-show="Math.round(classCycle / 4.25) >= 5">超出</span><span
                                            v-show="Math.round(classCycle / 4.25) <= 2">不足</span>1学期时间范围
                                    </p>
                                </div>
                            </a-form-item>

                            <!-- 课时总价 -->
                            <div :class="['', fixPrice && classifyIdValue == 2 ? 'tips' : '']">
                                <a-form-item label="课时总价" :labelCol="{ lg: { span: 7 } }"
                                    :wrapperCol="{ lg: { span: 13 } }">
                                    <a-input-number :min="0" :max="10000" style="width: 100%"
                                        @focus="coursePriceChangeFocus" @change="coursePriceChange"
                                        :disabled="platformCourse || (fixPrice && classifyIdValue == 2)" v-decorator="[
                                            'coursePrice',
                                            {
                                                rules: [
                                                    { required: !(fixPrice && classifyIdValue == 2), message: '请输入' },
                                                    {
                                                        pattern: /^(\d+)(.\d{0,2})?$/,
                                                        message: '最多两位小数',
                                                    },
                                                ],
                                                validateTrigger: 'change',
                                            },
                                        ]" />
                                    <!-- <span v-if="(roleId ==3?(fixPrice && classifyIdValue ==2):roleId ==4?(fixPrice && classifyIdValue ==1):false)">注：不可自主定价</span> -->
                                </a-form-item>
                            </div>
                            <!-- 是否包含教材/教具 -->
                            <a-form-item label="是否包含教材/教具" :labelCol="{ lg: { span: 7 } }"
                                :wrapperCol="{ lg: { span: 13 } }">
                                <a-select placeholder="请选择" :disabled="platformCourse" @change="hasTextbookChange"
                                    v-decorator="[
                                        'hasTextbook',
                                        { rules: [{ required: true, message: '请选择' }] },
                                    ]">
                                    <a-select-option v-for="(item, index) in hasTextbookOptions" :key="index"
                                        :value="item.value.toString()">{{ item.code }}</a-select-option>
                                </a-select>
                            </a-form-item>

                            <!-- 包含，显示后面选项 -->
                            <template v-if="this.hasTextbook == '1'">
                                <a-form-item label="教材/教具名称" :labelCol="{ lg: { span: 7 } }"
                                    :wrapperCol="{ lg: { span: 13 } }">
                                    <a-input :disabled="platformCourse" v-decorator="[
                                        'textbook',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    pattern: /^.{2,12}$/,
                                                    message: '请输入长度为2~12位的教材名称',
                                                },
                                            ],
                                            validateTrigger: 'change',
                                        },
                                    ]" />
                                    <div class="shelter"></div>
                                </a-form-item>

                                <!-- 教材价格 -->
                                <div :class="['', (fixPrice && classifyIdValue == 2) ? 'tips' : '']">
                                    <a-form-item label="教材/教具价格" :labelCol="{ lg: { span: 7 } }"
                                        :wrapperCol="{ lg: { span: 13 } }">
                                        <a-input-number :min="0" :max="10000" style="width: 100%"
                                            :disabled="platformCourse || (fixPrice && classifyIdValue == 2)"
                                            v-decorator="[
                                                'textbookPrice',
                                                {
                                                    rules: [
                                                        { required: !(fixPrice && classifyIdValue == 2), message: '请输入' },
                                                        {
                                                            pattern: /^(\d+)(.\d{0,2})?$/,
                                                            message: '最多两位小数',
                                                        },
                                                    ],
                                                    validateTrigger: 'change',
                                                },
                                            ]" />
                                        <span v-if="(fixPrice && classifyIdValue == 2)">注：不可自主定价</span>
                                    </a-form-item>
                                </div>

                                <!-- 是否必须购买 -->
                                <a-form-item label="是否必须购买" :labelCol="{ lg: { span: 7 } }"
                                    :wrapperCol="{ lg: { span: 13 } }">
                                    <a-radio-group :options="shoppingOptions" :disabled="platformCourse" v-decorator="[
                                        'textbookRequired',
                                        { rules: [{ required: true, message: '请选择' }] },
                                    ]" />
                                </a-form-item>
                            </template>
                        </a-form>

                        <div v-show="current == 1" ref="step2Ref" class="max-height">
                            <div class="lesson-item" v-for="(item, index) in courseLesson" :key="index"
                                ref="lessonItemRef">
                                <div class="lesson-title">
                                    课节{{ index + 1 }}/{{ classHourCount }}
                                </div>
                                <a-form-item label="课节标题" :labelCol="{ lg: { span: 4 } }"
                                    :wrapperCol="{ lg: { span: 18 } }" :required="index < 3">
                                    <a-input type="text" :maxLength="120" v-model="courseLesson[index].title"
                                        style="width: 450px" :disabled="platformCourse"></a-input>
                                </a-form-item>

                                <a-form-item label="课节内容" :labelCol="{ lg: { span: 4 } }"
                                    :wrapperCol="{ lg: { span: 18 } }">
                                    <a-textarea placeholder="请输入" :disabled="platformCourse"
                                        style="min-height: 55px;width: 450px" maxlength="100"
                                        v-model="courseLesson[index].content" />
                                </a-form-item>

                                <a-form-item label="课节资源" :labelCol="{ lg: { span: 4 } }"
                                    :wrapperCol="{ lg: { span: 20 } }">
                                    <c-progress name="上传文件" ref="lessonResource1" :isDisabled="platformCourse"
                                        :backIndex.sync="index" title="1.授课课件" tips="请上传视频/音频/pdf或者zip格式（ppt需转成pdf）"
                                        accept="audio/*,video/*,.zip,.pdf" lesType="1"
                                        :videoObj="courseLesson[index].lessonResource"
                                        @uploadSuccess="uploadSuccess_attachment"
                                        @buttonDisabled="buttonDisabled"></c-progress>

                                    <c-progress name="上传文件" ref="lessonResource3" :isDisabled="platformCourse"
                                        :backIndex.sync="index" title="2.课程视频片段" tips="请上传视频/音频/pdf或者zip格式"
                                        accept="audio/*,video/*,.zip,.pdf" lesType="2"
                                        :videoObj="courseLesson[index].lessonResource"
                                        @uploadSuccess="uploadSuccess_attachment"
                                        @buttonDisabled="buttonDisabled"></c-progress>

                                    <c-progress name="上传文件" ref="lessonResource2" :isDisabled="platformCourse"
                                        :backIndex.sync="index" title="3.教学教案" tips="文档格式/zip格式"
                                        accept=".pdf,.doc,.docx,.xls,.xlsx,.pot,.dot,.pps,.ppt,.pptx,.wps,.zip"
                                        lesType="3" icon="attachment" :videoObj="courseLesson[index].lessonResource"
                                        @uploadSuccess="uploadSuccess_attachment"
                                        @buttonDisabled="buttonDisabled"></c-progress>
                                </a-form-item>

                                <div class="delete hover-font-active" v-if="!platformCourse"
                                    @click="deletaLesson(index)">
                                    删除
                                </div>
                            </div>
                            <div class="add"
                                v-if="!platformCourse && form.getFieldValue('classHours') > courseLesson.length">
                                <a-button type="primary" @click="addCourseLesson">新增课节</a-button>
                            </div>
                        </div>

                        <div v-show="current == 2">
                            <c-richtext :editorContent.sync="editorContent" :disabled="platformCourse"></c-richtext>
                        </div>

                        <div class="steps-oper">
                            <a-button v-if="current > 0" @click="prev"> 上一步 </a-button>
                            <a-button class="prev" v-show="current < steps.length - 1" type="primary" @click="next"
                                style="margin-left: 10px">
                                下一步
                            </a-button>
                            <a-button class="submit" v-if="current == steps.length - 1" type="primary"
                                @click="handleSubmit">
                                确定
                            </a-button>
                            <a-modal :closable="false" :visible="submitVisible" :confirm-loading="confirmLoading"
                                :width="327" :footer="null">
                                <div style="text-align: center; margin-bottom: 17px">
                                    {{ tips1 }}
                                </div>
                                {{ tips2 }}
                                <div style="text-align: center; margin-top: 17px">
                                    <a-button type="primary" style="margin-right: 18px" @click="submitOk">确定</a-button>
                                    <a-button @click="submitCancel">取消</a-button>
                                </div>
                            </a-modal>
                        </div>
                    </div>
                </a-spin>
            </div>
        </div>
    </a-drawer>
</template>

<script>
import course from '../../../api/course'

import CUpload from '../../../components/CUpload' // 封面上传

import institution from '../../../api/institution'

import school from '../../../api/school'

import CRichtext from '../../../components/CRichtext' // 课程介绍

import CProgress from '../../../components/CProgress'

import weekList from '../../../code/weekList'

import bureau from '../../../api/bureau'

import user from '../../../api/user'

import { analysisAddress } from '../../../utils/address'

import Vue from 'vue'
export default {
    name: "CourseCenterForm",
    components: {
        CRichtext,
        CUpload,
        CProgress,
    },
    props: {
        showDrawer: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            visible: false,
            submitVisible: false,
            confirmLoading: false,
            form: this.$form.createForm(this),
            isAdd: true,
            courseId: '',
            updateData: {},
            editorContent: '', //编辑器内容
            avatarUrl: '', //头像
            sourceFileList: [], //头像回显
            steps: [
                {
                    title: '基本信息',
                },
                {
                    title: '课节内容',
                },
                {
                    title: '课程介绍',
                },
            ],
            shoppingOptions: [
                { label: '是', value: '1' },
                { label: '否', value: '0' },
            ],
            hasTextbookOptions: [
                { code: '是', value: '1' },
                { code: '否', value: '0' }
            ],
            schoolGradeList: [],
            current: 0,
            sourceType: '', //平台来源
            schoolServiceList: [], //服务学校List
            searchlLoading_serviceSchool: false, //搜索学校loading
            searchLoading_course: false, //搜索课程loading
            roleId: '', //角色ID
            courseLesson: [], //课节内容
            showPlatformSelect: null, //是否显示平台选择
            courseList: [], //选择平台的课
            fromCourseId: '', //如果选择平台的课，需要把平台的ID带进去
            weekList: weekList,
            courseLevelList: [
                { code: '1', value: '初级班' },
                { code: '2', value: '中级班' },
                { code: '3', value: '高级班' },
            ],
            bureauList: [],
            // gapTime: [
            //     30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120, 125, 130,
            //     135, 140, 145, 150, 155, 160, 165, 170, 175, 180,
            // ],
            gapTime: [],
            coursePriceSave: '',  // 如果不能自主定价，并且是不能的课程分类且有值，保存之前的值
            textbookPriceSave: '', // 如果不能自主定价，并且是不能的课程分类且有值，保存之前的值
            fixPrice: false,
            bureauId: '', //当前站点ID
            hasTextbook: '',
            classifyIdValue: null,
            tips1: '', // 新建或修改课程提示文本
            tips2: '', // 修改课程提示文本
            disabledSpin: false,
            gradeArr: [], //年级
            errGrades: [], //失效的年级
            errGradeText: "",
            // institutionId: null,
            whiteListFlag: false,
            upperFlag: false,
            classFrequency: 0,
            classHourCount: 0
        }
    },
    computed: {
        platformCourse() {
            // 课程来源为平台，但是当前用户不是平台
            return this.sourceType == '3' && this.roleId != '6' ? true : false
        },
        classCycle() {
            let cycle
            if (this.classFrequency && this.classHourCount) {
                cycle = Math.ceil(this.classHourCount / this.classFrequency)
                if (cycle >= 20 || cycle <= 8) {
                    return cycle
                }
            }
        }
    },
    methods: {
        lowerLimitChange(e) {
            let temp = this.form.getFieldValue('upperLimit')
            this.upperFlag = temp === null ? true : false;
        },
        upperLimitChange(e) {
            let temp = this.form.getFieldValue('lowerLimit')
            if (temp === null) return
            this.upperFlag = (e === '' || e === null) ? true : false;
        },
        buttonDisabled(value) {
            this.disabledSpin = value
        },
        hasTextbookChange(value) {
            this.hasTextbook = value
        },

        classifyIdChange(value) {
            this.classifyIdValue = value
        },
        handleClassHoursChange(value) {
            this.classHourCount = value
        },
        coursePriceChange(value) {
        },
        coursePriceChangeFocus(value) {
            // console.log(value,'coursePriceChangeFocus')
        },
        //设置全部学校
        allServiceSchool() {
            const tempList = []
            this.schoolServiceList.map((item) => {
                tempList.push(item.id)
            })
            this.form.setFieldsValue({ serviceSchoolId: tempList })
        },

        clearServiceSchool() {
            this.form.setFieldsValue({ serviceSchoolId: [] })
        },

        //获取代理列表
        selectSearchBureau(val = '', id) {
            let req = {
                bureauName: val,
            }
            if (id) {
                req.id = id
            }
            bureau.selectSearchBureau(req).then((res) => {
                this.bureauList = res.data
            })
        },

        //选择我们的课程
        chooseUsCourse() {
            this.sourceType = '2'
            this.showPlatformSelect = false
            setTimeout(() => {
                this.form.setFieldsValue({
                    teachingTime_start: 30,
                    teachingTime_end: 60,
                })
            }, 100)
        },

        // 下载文件回调
        uploadSuccess_attachment(backIndex) {
            //只有obj存在，新增，反之删除
            const lessonResource1 =
                this.$refs.lessonResource1[backIndex].successUpload_data()
            const lessonResource2 =
                this.$refs.lessonResource2[backIndex].successUpload_data()
            const lessonResource3 =
                this.$refs.lessonResource3[backIndex].successUpload_data()
            this.$set(this.courseLesson[backIndex], 'lessonResource', [
                ...lessonResource1,
                ...lessonResource2,
                ...lessonResource3,
            ])
        },

        classWeeks_change() {
            setTimeout(() => {
                this.form.getFieldValue('classWeeks').sort((a, b) => parseInt(a) - parseInt(b))
                this.classFrequency = this.form.getFieldValue('classWeeks').length
            }, 0)
        },
        //初始化平台
        initShowPlatformSelect() {
            //如果是平台，就直接创建
            this.showPlatformSelect = true
        },

        //删除课节
        deletaLesson(index) {
            this.courseLesson.splice(index, 1)
        },

        //新增课节内容
        addCourseLesson() {
            this.courseLesson.push({
                classPeriodNum: this.courseLesson.length + 1,
                title: '',
                content: '',
            })
            // console.log(this.courseLesson)
        },

        //封面上传成功之后回调
        uploadSuccess(url) {
            this.avatarUrl = url
        },

        //下一步
        next() {
            //校验
            this.upperFlag = (this.form.getFieldValue('lowerLimit') && this.form.getFieldValue('upperLimit')) ? false : true
            this.form.validateFields((err, value) => {
                // console.log('value校验', value)
                //校验通过
                if (!err) {
                    // 课节内容添加必传项
                    if (this.current == 0) {
                        let arrLength = this.classHourCount
                        if (arrLength > 20) arrLength = 20
                        if (this.courseLesson.length < arrLength) {
                            for (let index = 0; index < arrLength; index++) {
                                this.courseLesson.push({
                                    classPeriodNum: this.courseLesson.length + 1,
                                    title: '',
                                    content: '',
                                })
                                if (this.courseLesson.length == arrLength) {
                                    this.current++
                                    this.$nextTick(() => {
                                        this.$refs.step2Ref.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'start'
                                        });
                                    })
                                    return
                                }
                            }
                        }
                        return this.current++
                    }
                    // 判断课节内容页
                    if (this.current == 1) {
                        // 校验前三项标题是否填写
                        let min = Math.min(3, this.classHourCount)
                        if (this.courseLesson.length < min) {
                            this.$message.error(`请至少添加${min}节课节`)
                            return
                        }
                        for (let i = 0; i < min; i++) {
                            if (!this.courseLesson[i].title) {
                                this.$message.error(`请填写第${i + 1}节课标题`)
                                this.$nextTick(() => {
                                    this.$refs.lessonItemRef[i].scrollIntoView({
                                        behavior: 'smooth',
                                        block: 'start'
                                    });
                                })
                                return
                            }
                        }
                        // 校验课节完整
                        let checkCourseCount = this.checkCourseLesson()
                        if (!checkCourseCount) return
                        if (checkCourseCount !== this.classHourCount) {
                            let _this = this
                            this.$confirm({
                                title: '确定要修改课程?',
                                content: '提交的课程大纲' + checkCourseCount + '节与课时数' + this.classHourCount + '不相符，是否确认提交',
                                onOk() {
                                    _this.current++
                                },
                                onCancel() {
                                    return
                                },
                            });
                        } else {
                            this.current++
                        }
                    }
                }
            })
        },
        prev() {
            this.current--
        },
        // 校验课节完整
        checkCourseLesson() {
            let count = 0
            // 检验中间是否有空的item
            let lastIndex = -1
            let firstEmptyIndex = 0
            let tempArr = [...this.courseLesson]
            tempArr.reverse().forEach((item, index) => {
                if (lastIndex == -1) {
                    if (item.title || item.content || item.lessonResource) {
                        lastIndex = index
                    }
                }
                if (index > lastIndex && lastIndex > -1 && !item.title && !item.content && !(item.lessonResource && item.lessonResource.length)) {
                    firstEmptyIndex = this.courseLesson.length - index
                    return
                }
            })
            if (firstEmptyIndex) {
                this.$message.error(`第${firstEmptyIndex}课节未填写`)
                this.$nextTick(() => {
                    this.$refs.lessonItemRef[firstEmptyIndex - 1].scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                })
                return false
            }
            this.courseLesson.forEach(item => {
                if (item.title || item.content || item.lessonResource && item.lessonResource.length) {
                    count++
                }
            })
            return count
        },

        //搜索服务学校
        searchServiceSchool(val = '') {
            this.searchlLoading_serviceSchool = true
            school.selectSchoolOfBureau({ schoolName: val }).then((res) => {
                this.searchlLoading_serviceSchool = false
                this.schoolServiceList = res.data
            })
        },

        //初始化，显示
        init(type, receiveParams) {
            // console.log('receiveParams', receiveParams)

            // console.log(params,'formform')
            for (var i = 30; i <= 720; i += 5) {
                this.gapTime.push(i)
            }
            // 获取服务学校
            this.searchServiceSchool()

            this.visible = true
            this.current = 0
            this.courseLesson = []
            this.fromCourseId = ''
            this.avatarUrl = ''
            this.isAdd = type === 'update' ? false : true
            if (this.isAdd = type === 'update' ? false : true) {
                this.classifyIdValue = ''
            }
            this.selectSearchBureau()
            this.hasTextbook = ''
            course.modifyCourse(type).then((res) => {
                this.tips1 = res.data.tips1
                this.tips2 = res.data.tips2
            })
            if (!this.isAdd || type == 'copy') {
                const params = JSON.parse(JSON.stringify(receiveParams))
                //初始化form表单数据
                if (params) {
                    this.updateData = params
                    let formData = {}
                    //修改不用选择平台
                    this.showPlatformSelect = false
                    formData.courseName = params.courseName
                    formData.classifyId = params.classifyId
                    this.classifyIdValue = params.classifyId

                    if (!this.isAdd && this.classifyIdValue == 2) {
                        this.coursePriceSave = params.coursePrice / 100
                        this.textbookPriceSave = params.textbookPrice / 100
                    }
                    formData.resourceType = params.resourceType.toString()
                    formData.webUrl = params.webUrl
                    if (params.cateFirstId && params.classifyId == 3) {
                        formData.cateList = [params.cateFirstId]
                    }
                    if (params.cateFirstId && params.cateSecondId) {
                        formData.cateList = [params.cateFirstId, params.cateSecondId]
                        if (params.cateThirdId) formData.cateList.push(params.cateThirdId)
                    }
                    // 处理年级数据
                    let tempGrade = []
                    formData.gradeScope = []
                    tempGrade = params.gradeScope.split(',')
                    tempGrade.forEach(item => {
                        if (this.gradeArr.includes(parseInt(item))) {
                            formData.gradeScope.push(item)
                        } else {
                            this.errGrades.push(parseInt(item))
                        }
                    })
                    if (this.errGrades) {
                        let temp = []
                        this.$store.getters.getGradeScope.forEach(item => {
                            if (this.errGrades.includes(item.id)) {
                                temp.push(item.tagName)
                            }
                        })
                        this.errGradeText = temp.join(',')
                    }
                    formData.lowerLimit = params.lowerLimit
                    formData.upperLimit = params.upperLimit
                    formData.classWeeks = params.classWeeks
                        ? params.classWeeks
                            .split(',')
                            .sort((a, b) => parseInt(a) - parseInt(b))
                        : []
                    this.classFrequency = formData.classWeeks.length
                    formData.placeRemark = params.placeRemark
                    formData.courseLevel = params.courseLevel
                        ? params.courseLevel.toString()
                        : ''

                    //建议教学时间
                    const teachingTimeList = params.teachingTime
                        ? params.teachingTime.split('-')
                        : []
                    if (teachingTimeList.length == 2) {
                        formData.teachingTime_start = teachingTimeList[0]
                        formData.teachingTime_end = teachingTimeList[1]
                    }
                    // formData.institutionId = params.institutionId
                    formData.schoolId = params.schoolId
                    formData.classHours = parseInt(params.classHours)
                    this.classHourCount = formData.classHours
                    formData.totalPrice = params.totalPrice / 100
                    formData.coursePrice = params.coursePrice / 100
                    this.editorContent = (!params.intro ? '' : params.intro)
                    formData.serviceSchoolId = params.serviceSchoolIdList
                    formData.textbook = params.textbook
                    // formData.hasTextbook =
                    //   params.hasTextbook || params.hasTextbook == 0
                    //     ? params.hasTextbook.toString()
                    //     : null
                    formData.hasTextbook = params.hasTextbook.toString()
                    this.hasTextbook = formData.hasTextbook
                    formData.textbookPrice = params.textbookPrice / 100
                    formData.textbookRequired =
                        params.textbookRequired || params.textbookRequired == 0
                            ? params.textbookRequired.toString()
                            : null
                    formData.lessonResource = params.lessonResource
                    //课节内容
                    this.courseLesson = params.courseLesson ? params.courseLesson : []
                    this.courseLesson.forEach((v, i) => {
                        v.classPeriodNum = i + 1
                    })
                    //记录当前课程的ID
                    this.courseId = params.id
                    this.sourceType = params.sourceType
                    this.fromCourseId = params.fromCourseId
                    this.sourceFileList = [params.coverUrl]
                    this.serviceSchoolBack(params)

                    this.$nextTick(() => {
                        this.setValue(formData)
                        //如果包含教材，在set一次，因为教材的显示需要hasTextbook字段
                        if (formData.hasTextbook == 1) {
                            this.$nextTick(() => {
                                this.form.setFieldsValue({
                                    hasTextbook: formData.hasTextbook,
                                    textbook: formData.textbook,
                                    textbookPrice: formData.textbookPrice,
                                    textbookRequired: formData.textbookRequired,
                                })
                            })
                        }
                    })
                }
            } else {
                this.sourceFileList = []
                this.editorContent = ''
                this.bureauId = ''
                this.initShowPlatformSelect()
                this.form.resetFields()
                this.initSourceType()

                setTimeout(() => {
                    this.form.setFieldsValue({
                        teachingTime_start: 30,
                        teachingTime_end: 60,
                    })
                }, 100)
            }

            let teaBureauSetting = Vue.ls.get('teaBureauSetting')
            for (let i in teaBureauSetting) {
                if (teaBureauSetting[i].settingKey == 'course_classify2_price_confirm_by_school' && teaBureauSetting[i].settingValue == '0') {
                    this.fixPrice = true
                }
                else if (teaBureauSetting[i].settingKey == 'course_classify2_price_confirm_by_school' && teaBureauSetting[i].settingValue == '1') {
                    this.fixPrice = false
                }
            }
        },

        //服务公校回显
        serviceSchoolBack(params) {
            if (!params.serviceSchoolIdList) return
            for (let i = 0; i < params.serviceSchoolIdList.length; i++) {
                let hasId = false
                this.schoolServiceList.map((item) => {
                    if (item.id == params.serviceSchoolIdList[i]) {
                        hasId = true
                    }
                })
                if (!hasId) {
                    this.schoolServiceList.push({
                        id: params.serviceSchoolIdList[i],
                        schoolName: params.serviceSchoolNameList[i],
                    })
                }
            }
        },
        setValue(formData) {
            this.form.setFieldsValue({
                bureauId: formData.bureauId,
                courseName: formData.courseName,
                classifyId: formData.classifyId,
                webUrl: formData.webUrl,
                cateList: formData.cateList,
                gradeScope: formData.gradeScope,
                lowerLimit: formData.lowerLimit,
                upperLimit: formData.upperLimit,
                classWeeks: formData.classWeeks,
                placeRemark: formData.placeRemark,
                courseLevel: formData.courseLevel,
                teachingTime_start: formData.teachingTime_start,
                teachingTime_end: formData.teachingTime_end,
                classHours: formData.classHours,
                coursePrice: formData.coursePrice,
                hasTextbook: formData.hasTextbook,
                lessonResource: formData.lessonResource,
            })
        },
        //隐藏
        handleCancel() {
            this.visible = false
            this.gapTime = []
            this.errGrades = []
            this.errGradeText = ''
            // this.form = {}
            this.courseId = ''
            this.updateData = {}
            this.editorContent = '' //编辑器内容
            this.avatarUrl = '' //头像
            this.sourceFileList = [] //头像回显
            this.current = 0
            this.sourceType = '' //平台来源
            this.schoolServiceList = [] //服务学校List
            this.searchlLoading_serviceSchool = false //搜索学校loading
            this.searchLoading_course = false //搜索课程loading
            this.courseLesson = [] //课节内容
            this.showPlatformSelect = null //是否显示平台选择
            this.courseList = [] //选择平台的课
            this.fromCourseId = '' //如果选择平台的课，需要把平台的ID带进去
            this.bureauList = []
            this.gapTime = []
            this.bureauId = '' //当前站点ID
            this.hasTextbook = ''
            this.tips1 = '' // 新建或修改课程提示文本
            this.tips2 = '' // 修改课程提示文本
            this.disabledSpin = false
            this.upperFlag = false
            this.classFrequency = 0,
                this.classHourCount = 0
        },

        //提交表单
        handleSubmit() {
            this.submitVisible = true

        },

        // 提交表单
        submitOk(e) {
            // console.log('保存')
            e.preventDefault()
            this.gapTime = []
            this.form.validateFields((err, value) => {
                if (this.classifyIdValue == "2" && this.fixPrice == true) {
                    value.coursePrice = ''
                    value.textbookPrice = ''
                }
                //校验通过
                if (!err) {
                    //处理上课周期
                    if (value.classWeeks && value.classWeeks.length > 0) {
                        value.classWeeks = value.classWeeks.join()
                    }

                    //处理年级范围
                    if (value.gradeScope && value.gradeScope.length > 0) {
                        value.gradeScope = value.gradeScope.join()
                    }

                    //总价格
                    value.totalPrice = value.textbookPrice
                        ? utils.common.accAdd(value.coursePrice, value.textbookPrice)
                        : value.coursePrice

                    //服务学校
                    if (value.serviceSchoolId && value.serviceSchoolId.length > 0) {
                        value.serviceSchoolId = value.serviceSchoolId.join()
                    }
                    //建议教学时间
                    value.teachingTime =
                        value.teachingTime_start + '-' + value.teachingTime_end
                    //课程介绍
                    value.intro = this.editorContent
                    //头像
                    value.coverUrl = this.avatarUrl || this.sourceFileList[0]
                    //平台类型
                    value.sourceType = this.sourceType
                    //如果选择的是平台课程，对应的ID
                    value.fromCourseId = this.fromCourseId
                    //课程类目
                    value.cateFirstId = value.cateList[0]
                    value.cateSecondId = value.cateList[1]
                    value.cateThirdId = value.cateList[2]
                    delete value.cateList
                    //课节内容
                    if (this.courseLesson && this.courseLesson.length > 0) {
                        for (
                            let i = 0, isDelete = false;
                            i < this.courseLesson.length;
                            i = isDelete ? i : i + 1
                        ) {
                            //如果课程里面什么都没有，删除当前项
                            if (
                                !this.courseLesson[i].title &&
                                !this.courseLesson[i].content
                            ) {
                                this.courseLesson.splice(i, 1)
                                isDelete = true
                            } else {
                                //删除课节里面的时间（后台需要）
                                delete this.courseLesson[i].gmtCreate
                                delete this.courseLesson[i].gmtModified
                                isDelete = false
                            }
                        }
                        value.courseLesson = JSON.stringify(this.courseLesson)
                    }
                    if (value.intro && (value.intro.length > 30000)) {
                        this.$message.error('课程介绍内容长度' + value.intro.length + '，请删减内容到长度30000以内')
                    } else if (this.isAdd) {
                        this.addCourse(value)
                    } else {
                        this.updateCourse(value)
                    }
                    this.submitVisible = false
                } else {
                    // console.log('异常的内容是：', err)
                }
            })
        },

        // 关闭是否提交提示框
        submitCancel() {
            this.submitVisible = false
        },

        //新增课程
        addCourse(value) {
            course.addCourse(value).then((res) => {
                this.$message.success('新增成功')
                this.close()
                this.$emit('refresh')
            }).catch((err) => {
                // console.log(err, 'err')
                if (err.code == 2168 || err.code == 2169) {
                    this.$error({ title: '请关闭新建课程窗口，刷新页面后重试' })
                    user.init().then((res) => {
                        // console.log('res-----------', res)
                        //码表拼接
                        Vue.ls.set('teaBureauSetting', res.teaBureauSetting)
                    })
                }
            })
        },
        //修改课程
        updateCourse(value) {
            course.updateCourse(this.courseId, value).then((res) => {
                this.$message.success('修改成功')
                Object.assign(this.updateData, value)
                this.$emit('refresh')
                this.close()
            }).catch((err) => {
                // console.log(err, 'errerrerrerr')
                this.$error({ title: '请关闭修改信息窗口，刷新页面后重试' })
                if (err.code == 2168 || err.code == 2169) {
                    this.$message.
                        user.init().then((res) => {
                            // console.log('res-----------', res)
                            //码表拼接
                            Vue.ls.set('teaBureauSetting', res.teaBureauSetting)
                            // console.log(Vue.ls.get('teaBureauSetting'), 'res-----------')
                        })
                }
            })
        },

        //平台课程列表
        searchCourse(val = '') {
            this.searchLoading_course = true
            course.selectSearch({ courseName: val }).then((res) => {
                this.searchLoading_course = false
                this.courseList = res.data
            })
        },

        //选择一个课程
        courseChange(id) {
            course.getCourseById(id).then((res) => {
                let params = res.data
                let formData = {}
                formData.courseName = params.courseName
                formData.classifyId = params.classifyId
                formData.resourceType = params.resourceType.toString()
                formData.webUrl = params.webUrl
                if (params.cateFirstId && params.cateSecondId) {
                    formData.cateList = [params.cateFirstId, params.cateSecondId]
                    if (params.cateThirdId) formData.cateList.push(params.cateThirdId)
                }
                formData.gradeScope = params.gradeScope
                    ? params.gradeScope.split(',')
                    : []
                formData.lowerLimit = params.lowerLimit
                formData.upperLimit = params.upperLimit
                formData.classWeeks = params.classWeeks
                    ? params.classWeeks
                        .split(',')
                        .sort((a, b) => parseInt(a) - parseInt(b))
                    : []
                formData.placeRemark = params.placeRemark
                formData.courseLevel = params.courseLevel
                    ? params.courseLevel.toString()
                    : ''
                //建议教学时间
                const teachingTimeList = params.teachingTime
                    ? params.teachingTime.split('-')
                    : []
                if (teachingTimeList.length == 2) {
                    formData.teachingTime_start = teachingTimeList[0]
                    formData.teachingTime_end = teachingTimeList[1]
                }
                // formData.institutionId = params.institutionId
                formData.schoolId = params.schoolId
                formData.classHours = parseInt(params.classHours)
                formData.totalPrice = params.totalPrice / 100
                formData.coursePrice = params.coursePrice / 100
                this.editorContent = params.intro
                this.sourceFileList = [params.coverUrl]
                this.courseLesson = params.courseLesson ? params.courseLesson : []
                this.sourceType = params.sourceType
                this.fromCourseId = params.id
                formData.textbook = params.textbook
                formData.hasTextbook =
                    params.hasTextbook || params.hasTextbook == 0
                        ? params.hasTextbook.toString()
                        : null
                this.hasTextbook = formData.hasTextbook
                formData.textbookPrice = params.textbookPrice / 100
                formData.textbookRequired =
                    params.textbookRequired || params.textbookRequired == 0
                        ? params.textbookRequired.toString()
                        : null
                formData.lessonResource = params.lessonResource
                setTimeout(() => {
                    this.form.setFieldsValue(formData)
                    //如果包含教材，在set一次，因为教材的显示需要hasTextbook字段
                    setTimeout(() => {
                        this.form.setFieldsValue(formData)
                    }, 100)
                }, 100)
            })
        },

        //初始化平台类型
        initSourceType() {
            this.$store.dispatch('getUserInfo').then((res) => {
                // this.institutionId = res.id
                this.roleId = res.accRole.id
                //课程来源
                switch (this.roleId.toString()) {
                    case '6':
                        this.sourceType = '3'
                        break //平台
                    case '3':
                        this.sourceType = '1'
                        break //课程方
                    case '4':
                        this.sourceType = '2'
                        break //机构
                }
                this.initShowPlatformSelect()
            })
        },
        // 关闭详情抽屉
        close() {
            this.$emit("update:showDrawer", false);
            this.handleCancel();
        },
    },
    activated() {
    },
    created() {
        this.gradeArr = Vue.ls.get('schoolGrade').map(item => {
            return item.gradeTagId
        })
        //加载初始化码表
        this.searchServiceSchool()
        this.searchCourse()
        this.initSourceType()
        user.init().then((res) => {
            //码表拼接
            Vue.ls.set('teaBureauSetting', res.teaBureauSetting)
        })

        this.schoolGradeList = Vue.ls.get('schoolGrade')
    },
}
</script>

<style lang="scss" scoped>
@import 'src/config/var';

::v-deep .ant-drawer-body {
    font-family: PingFangSC, PingFang SC;
    padding: 0;
}

::v-deep .ant-divider {
    margin: 10px 0;
    background-color: #f0f3fb !important;
}

.close-img {
    position: absolute;
    top: 20px;
    right: 26px;
}

.loading {
    height: 100vh;
    width: 100%;
    padding-top: 35%;
}

.header {
    position: sticky;
    top: 0;
    z-index: 999;
    background: #F1F6FC;
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 70px 0 24px;

    button {
        color: #333;
        margin-left: 12px;
    }

    .title {
        font-weight: 600;
        font-size: 16px;
        color: #1B1D26;
    }
}

.form-box {
    width: 100%;
    min-width: 800px;
    display: flex;
    justify-content: center;
    padding: 24px;
}

.course-form {
    width: 800px;
}

.course-form ::v-deep .ant-input {
    width: 100%;
}

.course-form ::v-deep .ant-select {
    width: 100%;
}

.person-scope {
    width: 100px;
    text-align: center;
    display: inline-block;
}

.person-gap {
    width: 35px !important;
    border-left: none;
    pointer-events: none;
    background: #fff;
}

.errGrade {
    margin-top: 2px;
    width: 30vw;
    height: 16px;
    font-size: 12px;
    color: silver;
    line-height: 14px;
}

.upper-explain {
    height: 0px;
    line-height: 16px;
    color: #f5222d;
}

.noUpper {
    border: 1px solid #f5222d;
}

.noUpper2 {
    border: 1px solid #f5222d;
    border-left: none;
    border-right: none;
}

.noUpper3 {
    border: 1px solid #f5222d;
    border-left: none;
}

::selection {
    background: #1890ff !important;
    color: #fff !important;
}

.course-info {
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #999
}

.lesson-item {
    border-bottom: 1px solid $border-color;
    width: 100%;
    display: inline-block;
    padding: 10px 20px 10px 50px;
    margin: 10px 0px;
    position: relative;

    .lesson-title {
        position: absolute;
        left: 0;
        top: 20px;
        font-weight: bold;
    }

    .delete {
        cursor: pointer;
        color: $normal-color-dark;
        position: absolute;
        right: 40px;
        top: 27px;
        transform: translateY(-50%);
    }
}

.steps-oper {
    margin-top: 12px;
    text-align: right;

    .submit {
        margin-left: 10px;
    }

    .prev {
        margin-right: 10px;
    }
}

.max-height {
    max-height: calc(100vh - 230px);
    overflow: auto;
}
</style>